customElements.whenDefined('variant-picker').then(() => {
  const prototype = customElements.get('variant-picker').prototype;
  if (prototype.dwcFpoLabelsEnabled) return;
  prototype.dwcFpoLabelsEnabled = true;

  const updateContent = prototype.updateContent;
  prototype.updateContent = function updateFpoContent(target, newContent, productChange, replacementMode = 'all') {
    const refreshLabels = this.dataset.requestView === 'fpo-rollers'
      && target && newContent && !productChange && this.getSelectedOptions().includes(null);
    updateContent.call(this, target, newContent, productChange, replacementMode);
    if (!refreshLabels) return;
    target.querySelectorAll('[data-dwc-fpo-bearing] .js-option[data-value-id]').forEach((input) => {
      const label = target.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      const nextLabel = newContent.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (label && nextLabel) label.innerHTML = nextLabel.innerHTML;
    });
  };

  const updateUrl = prototype.updateUrl;
  prototype.updateUrl = function updateFpoUrl() {
    if (this.dataset.requestView !== 'fpo-rollers') {
      return updateUrl.call(this);
    }
    if (this.dataset.updateUrl === 'false') return;
    const url = new URL(this.dataset.url, window.location.origin);
    url.searchParams.set('view', 'fpo-rollers');
    if (this.variant) url.searchParams.set('variant', this.variant.id);
    const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    window.history.replaceState({}, '', url.toString());
  };
});
